import FetchApi from "../util/fetchApi";
const fetchApi = new FetchApi();

export default class GeneralSettingsService {
  async getEmailSettings() {
    return (await fetchApi.get(`/generalSettings/getEmailSettings`)).data;
  }

  async addEmailSettings(postData) {
    return (await fetchApi.post(`/generalSettings/EmailSettings`, postData)).data;
  }

  async getHomePageConfiguration() {
    return (await fetchApi.get(`/generalSettings/homePageConfiguration`)).data;
  }

  async updateHomepageConfiguration(postData) {
    return (await fetchApi.post(`/generalSettings/homePageConfiguration`, postData)).data;
  }

  async getGeneralSettingDetails() {
    return (await fetchApi.get(`/generalSettings/generalTab`)).data;
  }

  async updateGeneralSettings(postData) {
    return (await fetchApi.post(`/generalSettings/generalTab`, postData)).data;
  }

  async getAppHostingConfiguration() {
    return (await fetchApi.get(`/generalSettings/appHosting`)).data;
  }

  async updateAppHostingConfiguration(postData) {
    return (await fetchApi.post(`/generalSettings/appHosting`, postData)).data;
  }

  async getDataAIConfigurations() {
    return (await fetchApi.get(`/generalSettings/dataAI`)).data;
  }

  async updateDataAIConfigurations(postData) {
    return (await fetchApi.post(`/generalSettings/dataAI`, postData)).data;
  }

  async getSandboxDetails() {
    return (await fetchApi.get(`/generalSettings/sandbox`)).data;
  }

  async updateSandboxDetails(postData) {
    return (await fetchApi.post(`/generalSettings/sandbox`, postData)).data;
  }
}
